export function parseWKTCRS(wkt, options) {
  if (options !== null && options !== void 0 && options.debug) {
    console.log('[wktcrs] parse starting with\n', wkt);
  }
  wkt = wkt.replace(/[A-Z][A-Z\d_]+\[/gi, match => `["${match.substr(0, match.length - 1)}",`);
  wkt = wkt.replace(/, ?([A-Z][A-Z\d_]+[,\]])/gi, (match, p1) => {
    const varname = p1.substr(0, p1.length - 1);
    return ',' + `"${options !== null && options !== void 0 && options.raw ? 'raw:' : ''}${varname}"${p1[p1.length - 1]}`;
  });
  if (options !== null && options !== void 0 && options.raw) {
    wkt = wkt.replace(/, {0,2}(-?[\.\d]+)(?=,|\])/g, function (match, p1) {
      return ',' + `"${options !== null && options !== void 0 && options.raw ? 'raw:' : ''}${p1}"`;
    });
  }
  if (options !== null && options !== void 0 && options.debug) {
    console.log(`[wktcrs] json'd wkt: '${wkt}'`);
  }
  let data;
  try {
    data = JSON.parse(wkt);
  } catch (error) {
    console.error(`[wktcrs] failed to parse '${wkt}'`);
    throw error;
  }
  if (options !== null && options !== void 0 && options.debug) {
    console.log(`[wktcrs] json parsed: '${wkt}'`);
  }
  function process(data, parent) {
    const kw = data[0];
    data.forEach(function (it) {
      if (Array.isArray(it)) {
        process(it, data);
      }
    });
    const kwarr = `MULTIPLE_${kw}`;
    if (kwarr in parent) {
      parent[kwarr].push(data);
    } else if (kw in parent) {
      parent[kwarr] = [parent[kw], data];
      delete parent[kw];
    } else {
      parent[kw] = data;
    }
    return parent;
  }
  const result = process(data, [data]);
  if (options !== null && options !== void 0 && options.debug) {
    console.log('[wktcrs] parse returning', result);
  }
  if (options !== null && options !== void 0 && options.sort) {
    sort(result, options);
  }
  return result;
}
function sort(data, options) {
  const keys = Object.keys(data).filter(k => !/\d+/.test(k));
  const keywords = (options === null || options === void 0 ? void 0 : options.keywords) || [];
  if (!(options !== null && options !== void 0 && options.keywords)) {
    const counts = {};
    if (Array.isArray(data)) {
      data.forEach(it => {
        if (Array.isArray(it) && it.length >= 2 && typeof it[1] === 'string') {
          const k = it[0];
          if (!counts[k]) counts[k] = 0;
          counts[k]++;
        }
      });
      for (const k in counts) {
        if (counts[k] > 0) keywords.push(k);
      }
    }
  }
  keys.forEach(key => {
    data[key] = sort(data[key]);
  });
  keywords.forEach(key => {
    const indices = [];
    const params = [];
    data.forEach((item, i) => {
      if (Array.isArray(item) && item[0] === key) {
        indices.push(i);
        params.push(item);
      }
    });
    params.sort((a, b) => {
      a = a[1].toString();
      b = b[1].toString();
      return a < b ? -1 : a > b ? 1 : 0;
    });
    params.forEach((param, i) => {
      data[indices[i]] = param;
    });
  });
  return data;
}
//# sourceMappingURL=parse-wkt-crs.js.map